import React from 'react';
import {
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogLabel,
  AlertDialogOverlay
} from "@reach/alert-dialog";

const ConfirmDialogComponent = (props) => {
  const cancelRef = React.useRef();

  return (
    <AlertDialogOverlay className="dialog_backdrop" leastDestructiveRef={cancelRef}>
      <AlertDialogContent className="dialog_content">
        <AlertDialogLabel className="dialog_tit"></AlertDialogLabel>
        <AlertDialogDescription className="dialog_description">
          {props.description.map((txt, index) => {
            return(
              <span key={index}>
                {txt}
              </span>
              )
          })}
        </AlertDialogDescription>
        <div className="dialog_btn_area">
          <button className="btn-skyblue-line" ref={cancelRef} onClick={props.leftClick}>{props.leftText}</button>
          <button className="btn-skyblue" ref={cancelRef} onClick={props.rightClick}>{props.rightText}</button>
        </div>
      </AlertDialogContent>
    </AlertDialogOverlay>
  );
};

export default ConfirmDialogComponent;
